var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelatorio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.3 373h753.1v493H135.3z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M880.5 365h16v16h-16zM864.8 381h-15.7v-16h15.7v16z m-31.4 0h-15.7v-16h15.7v16z m-31.3 0h-15.7v-16h15.7v16z m-31.4 0H755v-16h15.7v16z m-31.4 0h-15.7v-16h15.7v16z m-31.3 0h-15.7v-16H708v16z m-31.4 0h-15.7v-16h15.7v16z m-31.4 0h-15.7v-16h15.7v16z m-31.3 0h-15.7v-16h15.7v16z m-31.4 0h-15.7v-16h15.7v16z m-31.4 0h-15.7v-16h15.7v16z m-31.4 0H504v-16h15.7v16z m-31.3 0h-15.7v-16h15.7v16z m-31.4 0h-15.7v-16H457v16z m-31.4 0H410v-16h15.7v16z m-31.3 0h-15.7v-16h15.7v16z m-31.4 0h-15.7v-16h15.7v16z m-31.4 0h-15.7v-16h15.7v16z m-31.3 0h-15.7v-16h15.7v16z m-31.4 0h-15.7v-16h15.7v16z m-31.4 0h-15.7v-16h15.7v16z m-31.3 0h-15.7v-16h15.7v16z m-31.4 0H159v-16h15.7v16zM127.3 365h16v16h-16zM143.3 841.5h-16v-16.4h16v16.4z m0-32.9h-16v-16.4h16v16.4z m0-32.8h-16v-16.4h16v16.4z m0-32.9h-16v-16.4h16v16.4z m0-32.9h-16v-16.4h16V710z m0-32.9h-16v-16.4h16v16.4z m0-32.9h-16v-16.4h16v16.4z m0-32.9h-16v-16.4h16v16.4z m0-32.9h-16V562h16v16.4z m0-32.9h-16v-16.4h16v16.4z m0-32.9h-16v-16.4h16v16.4z m0-32.9h-16v-16.4h16v16.4z m0-32.9h-16v-16.4h16v16.4z m0-32.9h-16v-16.4h16v16.4zM127.3 858h16v16h-16zM864.8 874h-15.7v-16h15.7v16z m-31.4 0h-15.7v-16h15.7v16z m-31.3 0h-15.7v-16h15.7v16z m-31.4 0H755v-16h15.7v16z m-31.4 0h-15.7v-16h15.7v16z m-31.3 0h-15.7v-16H708v16z m-31.4 0h-15.7v-16h15.7v16z m-31.4 0h-15.7v-16h15.7v16z m-31.3 0h-15.7v-16h15.7v16z m-31.4 0h-15.7v-16h15.7v16z m-31.4 0h-15.7v-16h15.7v16z m-31.4 0H504v-16h15.7v16z m-31.3 0h-15.7v-16h15.7v16z m-31.4 0h-15.7v-16H457v16z m-31.4 0H410v-16h15.7v16z m-31.3 0h-15.7v-16h15.7v16z m-31.4 0h-15.7v-16h15.7v16z m-31.4 0h-15.7v-16h15.7v16z m-31.3 0h-15.7v-16h15.7v16z m-31.4 0h-15.7v-16h15.7v16z m-31.4 0h-15.7v-16h15.7v16z m-31.3 0h-15.7v-16h15.7v16z m-31.4 0H159v-16h15.7v16zM880.5 858h16v16h-16zM896.5 841.5h-16v-16.4h16v16.4z m0-32.9h-16v-16.4h16v16.4z m0-32.8h-16v-16.4h16v16.4z m0-32.9h-16v-16.4h16v16.4z m0-32.9h-16v-16.4h16V710z m0-32.9h-16v-16.4h16v16.4z m0-32.9h-16v-16.4h16v16.4z m0-32.9h-16v-16.4h16v16.4z m0-32.9h-16V562h16v16.4z m0-32.9h-16v-16.4h16v16.4z m0-32.9h-16v-16.4h16v16.4z m0-32.9h-16v-16.4h16v16.4z m0-32.9h-16v-16.4h16v16.4z m0-32.9h-16v-16.4h16v16.4z",
    fill: "#0A0408"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M192.7 440.7h645.2v454.9H192.7z",
    fill: "#EBB866"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9 864.5H952v83.9H71.9z",
    fill: "#FFFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M959.9 956.4h-896v-99.9H960v99.9z m-880-16H944v-67.9H79.9v67.9z",
    fill: "#0A0408"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M314.5 334.1h84.4v319.7h-84.4z",
    fill: "#55B7A8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M406.9 661.8H306.5V326.1h100.4v335.7z m-84.4-16h68.4V342.1h-68.4v303.7z",
    fill: "#0A0408"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M475.3 145.7h84.4v508.1h-84.4z",
    fill: "#DC444A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M567.6 661.8H467.3V137.7h100.4v524.1z m-84.3-16h68.4V153.7h-68.4v492.1z",
    fill: "#0A0408"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M636 241.8h84.4v412H636z",
    fill: "#68A4D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M728.4 661.8H628v-428h100.4v428z m-84.4-16h68.4v-396H644v396z",
    fill: "#0A0408"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M314.5 308.7h84.4v110.8h-84.4z",
    fill: "#FFFFFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M406.9 427.5H306.5V300.7h100.4v126.8z m-84.4-16h68.4v-94.8h-68.4v94.8z",
    fill: "#0A0408"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M475.3 104h84.4v110.8h-84.4z",
    fill: "#FFFFFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M567.6 222.8H467.3V96h100.4v126.8z m-84.3-16h68.4V112h-68.4v94.8z",
    fill: "#0A0408"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M636 223.3h84.4v110.8H636z",
    fill: "#FFFFFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M728.4 342.1H628V215.3h100.4v126.8z m-84.4-16h68.4v-94.8H644v94.8z",
    fill: "#0A0408"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M314.5 742.2h8v16h-8zM696.8 758.2h-15.6v-16h15.6v16z m-31.2 0H650v-16h15.6v16z m-31.2 0h-15.6v-16h15.6v16z m-31.2 0h-15.6v-16h15.6v16z m-31.2 0h-15.6v-16H572v16z m-31.2 0h-15.6v-16h15.6v16z m-31.1 0h-15.6v-16h15.6v16z m-31.2 0h-15.6v-16h15.6v16z m-31.2 0h-15.6v-16h15.6v16z m-31.2 0h-15.6v-16h15.6v16z m-31.2 0h-15.6v-16h15.6v16z m-31.2 0h-15.6v-16h15.6v16zM712.4 742.2h8v16h-8z",
    fill: "#0A0408"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M109.9 347.6h50.9v50.9h-50.9z",
    fill: "#DC444A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M168.8 406.5h-66.9v-66.9h66.9v66.9z m-50.9-16h34.9v-34.9h-34.9v34.9z",
    fill: "#0A0408"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M863.7 346.9h50.9v50.9h-50.9z",
    fill: "#DC444A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M922.6 405.7h-66.9v-66.9h66.9v66.9z m-50.9-16h34.9v-34.9h-34.9v34.9z",
    fill: "#0A0408"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelatorio);
export default __webpack_public_path__ + "static/media/relatorio.195bdde6f14ff6b7392dc05a44a94dee.svg";
export { ForwardRef as ReactComponent };